<rt-dropdown (click)="$event.preventDefault()" rtScrollable #dropdown>
  <rt-dropdown-header [fullWidthTitle]="true">
    {{ 'app.redactor_inserts.dropdown.header' | translate }}
  </rt-dropdown-header>
  @for (insert of inserts; track trackByValue($index, insert)) {
    <rt-redactor-inserts-dropdown-item
      [iconName]="RedactorInsertStepTemplateMap[insert].icon"
      [heading]="RedactorInsertStepTemplateMap[insert].heading"
      [subheading]="RedactorInsertStepTemplateMap[insert].subheading"
      [targetFor]="RedactorInsertStepTemplateMap[insert].template"
      [selected]="isSelected(insert)"
    >
    </rt-redactor-inserts-dropdown-item>
  }
  <ng-template #questionnairesTemplates>
    <rt-redactor-inserts-questionnaires
      [hasBackAction]="hasBackAction"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (insertLink)="insertLink.emit($event)"
    >
    </rt-redactor-inserts-questionnaires>
  </ng-template>
  <ng-template #emailTemplates>
    <rt-redactor-inserts-email-templates
      [insideTemplate]="emailTemplateInsideTemplate"
      [hasBackAction]="hasBackAction"
      [kind]="InsertsEmailKind.EmailTemplate"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (emailTemplateChoose)="emailTemplateChoose.emit($event); closeDropdown()"
      (saveAsTemplate)="saveAsTemplate.emit(); closeDropdown()"
    >
    </rt-redactor-inserts-email-templates>
  </ng-template>
  <ng-template #eventInvitationTemplates>
    <rt-redactor-inserts-email-templates
      [insideTemplate]="emailTemplateInsideTemplate"
      [hasBackAction]="hasBackAction"
      [kind]="InsertsEmailKind.EventInvitation"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (emailTemplateChoose)="emailTemplateChoose.emit($event); closeDropdown()"
      (saveAsTemplate)="saveAsTemplate.emit(); closeDropdown()"
    >
    </rt-redactor-inserts-email-templates>
  </ng-template>
  <ng-template #schedules>
    <rt-redactor-inserts-scheduler
      [hasBackAction]="hasBackAction"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (insertLink)="insertLink.emit($event)"
    >
    </rt-redactor-inserts-scheduler>
  </ng-template>
  <ng-template #gdprLinks>
    <rt-redactor-inserts-gdpr
      [hasBackAction]="hasBackAction"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (insertLink)="insertLink.emit($event)"
    >
    </rt-redactor-inserts-gdpr>
  </ng-template>
  <ng-template #gdprLinksWithoutConsent>
    <rt-redactor-inserts-gdpr
      [hasBackAction]="hasBackAction"
      [isConsentRequestShow]="false"
      (back)="dropdown.prevTemplate()"
      (settings)="goToSettings($event)"
      (closeDropdown)="closeDropdown()"
      (insertLink)="insertLink.emit($event)"
    >
    </rt-redactor-inserts-gdpr>
  </ng-template>
  <ng-template #integrationsKununu>
    <rt-redactor-inserts-integrations-kununu
      [hasBackAction]="hasBackAction"
      (back)="dropdown.prevTemplate()"
      (closeDropdown)="closeDropdown()"
      (insertLink)="insertLink.emit($event)"
    >
    </rt-redactor-inserts-integrations-kununu>
  </ng-template>
</rt-dropdown>
